var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('v-data-table', _vm._b({
    staticClass: "v-data-table--sm purchase-table",
    attrs: {
      "disable-pagination": "",
      "disable-sort": "",
      "mobile-breakpoint": "768",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.orderNo",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.orderNo))];
      }
    }, {
      key: "item.product.name",
      fn: function fn(_ref2) {
        var _item$product;

        var item = _ref2.item;
        return [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.name))];
      }
    }, {
      key: "item.product",
      fn: function fn(_ref3) {
        var _item$product2;

        var item = _ref3.item;
        return _c('v-responsive', {}, [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "shrink": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.thumb,
            "width": "96",
            "height": "96",
            "contain": ""
          }
        })], 1)], 1)], 1);
      }
    }, {
      key: "item.option-addition",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.product.type == 'option' ? _c('div', [_vm._v("[" + _vm._s(item.product.optionalNames.toString()) + "] : " + _vm._s(item.product.optionalValues.toString()))]) : _vm._e(), item.product.type == 'addition' ? _c('div', [_vm._v("[" + _vm._s(item.product.additionalName.toString()) + "] : " + _vm._s(item.product.additionalValue.toString()))]) : _vm._e()];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.getOrderstatus(item)))]);
      }
    }, {
      key: "item.totalAmount",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return _c('span', {}, [_vm._v(_vm._s(item.totalAmount.format()) + "원")]);
      }
    }, {
      key: "item.shippingInfo",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return _c('span', {}, [_vm._v(_vm._s(item.shippingInfo.invoiceNumber))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))]);
      }
    }, {
      key: "item.resend",
      fn: function fn(_ref9) {
        var _item$issue, _item$issue$pins;

        var item = _ref9.item;
        return _c('span', {}, [(_item$issue = item.issue) !== null && _item$issue !== void 0 && (_item$issue$pins = _item$issue.pins) !== null && _item$issue$pins !== void 0 && _item$issue$pins.length ? _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.resend(item);
            }
          }
        }, [_vm._v("mdi-message")]) : _vm._e()], 1);
      }
    }, {
      key: "item.order.shippingAddress",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return _c('div', {}, [_c('div', [_vm._v("[" + _vm._s(item.order.shippingAddress.postcode) + "] " + _vm._s(item.order.shippingAddress.address1) + " " + _vm._s(item.order.shippingAddress.address2))])]);
      }
    }, {
      key: "item.detail",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c('v-btn', {
          staticClass: "white--text px-6px",
          attrs: {
            "to": "/mypage/shop/orders/".concat(item._id),
            "x-small": "",
            "color": "primary"
          }
        }, [_vm._v("보기")])];
      }
    }, {
      key: "item.specification",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [!['취소완료', '반품요청', '반품완료', '반품수거중', '반품수거완료'].includes(item.purchases[0].status) ? _c('v-btn', {
          staticClass: "px-6px",
          attrs: {
            "outlined": "",
            "x-small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.popup(item._id);
            }
          }
        }, [_vm._v("출력")]) : _vm._e()];
      }
    }, {
      key: "item.cashbill",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [item.cashbill.status ? _c('span', [_vm._v("신청")]) : _vm._e()];
      }
    }, {
      key: "item.purchaseName",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c('router-link', {
          staticClass: "click-link primary--text",
          attrs: {
            "to": "/mypage/shop/orders/".concat(item._id)
          }
        }, [_c('div', [_vm._v(_vm._s(item.purchases[0].product.name) + " " + _vm._s(item.purchases.length === 1 ? "" : "\uC678 ".concat(item.purchases.length - 1, "\uAC74")))])])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return _c('div', {}, [item.status == '주문완료' || item.status == '상품준비중' || item.status == '발송지연' ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "primary",
            "disabled": item.isClaim || item.giftStatus == '선물받기완료' || item.giftStatus == '선물포인트전환완료'
          },
          on: {
            "click": function click($event) {
              return _vm.claim(item, "cancel");
            }
          }
        }, [_vm._v("취소요청")]) : _vm._e(), item.status != '주문완료' && item.status != '상품준비중' && item.status != '발송지연' && item.purchaseStatus != '구매확정완료' && item.status != '취소완료' && item.status && !item.isClaim ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "primary",
            "disabled": item.isClaim
          },
          on: {
            "click": function click($event) {
              return _vm.claim(item, "return");
            }
          }
        }, [_vm._v("반품요청")]) : _vm._e(), item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus == '구매확정완료' || item.status == '반품반려' && item.isClaim && !item.review ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.review(item);
            }
          }
        }, [_vm._v("상품리뷰")]) : _vm._e(), item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus != '구매확정완료' ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "primary",
            "disabled": item.isClaim
          },
          on: {
            "click": function click($event) {
              return _vm.confirmation(item);
            }
          }
        }, [_vm._v("구매확정")]) : _vm._e()], 1);
      }
    }, {
      key: "null",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return _c('div', {}, [_c('v-btn', {
          staticClass: "white--text px-6px",
          attrs: {
            "x-small": "",
            "color": "primary",
            "disabled": item.isClaim
          },
          on: {
            "click": function click($event) {
              return _vm.claim(item, "cancel");
            }
          }
        }, [_vm._v("보기")])], 1);
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', _vm._b({
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  }, 'v-pagination', {
    value: _vm.page,
    length: _vm.pageCount,
    'total-visible': 11
  }, false))], 1), _c('claim-dialog', {
    ref: "claimDialog",
    on: {
      "claim": _vm.search
    }
  }), _c('review-dialog', {
    ref: "reviewDialog",
    on: {
      "close": _vm.search
    }
  }), _c('cashbill-dialog', {
    ref: "cashbillDialog",
    on: {
      "close": _vm.search
    }
  }), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }